import { portoAirportGuide } from './porto-airport-guide';
import { douroTourGuide } from './douro-tour-guide';
import { santiagoDayTrip } from './santiago-day-trip';

export const BLOG_POSTS = [
  portoAirportGuide,
  douroTourGuide,
  santiagoDayTrip,
];

// Get all posts with translation for a given language (fallback EN)
export const getPostsForLanguage = (lang) => {
  return BLOG_POSTS.map((post) => {
    const tr = post.translations[lang] || post.translations.en;
    return {
      slug: post.slug,
      publishDate: post.publishDate,
      readMinutes: post.readMinutes,
      image: post.image,
      category: post.category,
      ...tr,
    };
  }).sort((a, b) => new Date(b.publishDate) - new Date(a.publishDate));
};

// Get a single post by slug for a given language
export const getPostBySlug = (slug, lang) => {
  const post = BLOG_POSTS.find((p) => p.slug === slug);
  if (!post) return null;
  const tr = post.translations[lang] || post.translations.en;
  return {
    slug: post.slug,
    publishDate: post.publishDate,
    readMinutes: post.readMinutes,
    image: post.image,
    category: post.category,
    availableLanguages: Object.keys(post.translations),
    ...tr,
  };
};
